import ContainerGrid from './container-grid';

import ButtonPrevious from '../../components/buttons-navigation/button-previous';
import ButtonNext from '../../components/buttons-navigation/button-next';

import CustomDropdown from '../../components/inputs/dropdowns/dropdown';

function ContainerIndex({ children }) {
    return (
        <div className="container-index">
            { children }
        </div>
    )
}

ContainerIndex.Filters = ({ children }) => {
    return (
        <div className="container-index__filters">
            { children }
        </div>
    )
}

ContainerIndex.Content = ({ children, className = '', grid = true }) => {
    return (
        <div className="container-index__content">
            { grid ? <ContainerGrid className={className}>
                { children }
            </ContainerGrid> : children }
        </div>
    )
}

ContainerIndex.PaginationWithPageDropdown = ({
    currentPage = 0,
    onPrevious = () => {},
    onNext = () => {},
    setPage = () => {},
    meta = {}
}) => {
    const getOptions = () => {
        const items = new Array(meta?.last_page || 0).fill(0).map((_, index) => index + 1);

        const newItems = items.map((item) => ({
            label: item,
            value: item,
        }));

        return newItems;
    }

    const onChange = (e) => setPage(e.value);

    return (
        <div className="container-index__pagination">
            <ButtonPrevious onClick={onPrevious} disabled={currentPage === 1}>Prev</ButtonPrevious>
            <CustomDropdown items={getOptions()} placeholder="Jump to page" icon="arrow" onChange={onChange}/>
            <ButtonNext onClick={onNext} disabled={currentPage === meta?.last_page}>Next</ButtonNext>
        </div>
    )
}

ContainerIndex.Pagination = ({ 
    currentPage = 0,
    maxPages = 0,
    onPrevious = () => {},
    onNext = () => {},
    color = 'white'
}) => {
    return (
        <div className={`container-index__pagination container-index__pagination--${color}`}>
            <ButtonPrevious onClick={onPrevious} disabled={currentPage === 1}>Prev</ButtonPrevious>
            <p>{ currentPage } of { maxPages }</p>
            <ButtonNext onClick={onNext} disabled={currentPage === maxPages}>Next</ButtonNext>
        </div>
    )
}

export default ContainerIndex;